export enum LocationType {
  point = 'point',
  linear = 'linear'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/locationtype.ts